import React from 'react';
import { Div, SubText, DraftDiv } from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';

const AiblePlanPdfNotAvailable = ({ onClose }) => {
    const {t} = useTranslation();
    return (
        <>
            <Popup id={'surgery-notication-aiblePlanPdfNotAvailable-popup'} onClose={onClose} title={'AiBLE plan PDF is not available'}>
                <DraftDiv>
                    <SubText>
                        {t('scheduleSurgery.surgery.notifications.AiblePlanPdfNotAvailable.contactAibleLab')}
                    </SubText>
                    <Div>
                        <Button
                            id={'surgery-notifications-aibleplanpdfnotavailable-okbutton'}
                            show={true}
                            width={'80px'}
                            height={'38px'}
                            //primary={true}
                            variant={ButtonStyles?.primary}
                            margin={'5px 0px 5px 5px'}
                            fontSize={'13px'}
                            clicked={onClose}
                        >
                            {t('scheduleSurgery.surgery.notifications.DraftSaved.okButton')}
                        </Button>
                    </Div>
                </DraftDiv>
            </Popup>
        </>
    );
};

export default AiblePlanPdfNotAvailable;
